import React from "react";

const achievementsData = [
  {
    id: 1,
    label: "Maximum salary hike",
    value: "150%",
  },
  {
    id: 2,
    label: "Average salary hike",
    value: "70%",
  },
  {
    id: 3,
    label: "Hiring partners",
    value: "2900+",
  },
];

const companiesData = [
  {
    id: 1,
    name: "Accenture",
    logo: require("../../../assets/images/Accenture.avif"),
  },
  {
    id: 2,
    name: "Apple",
    logo: require("../../../assets/images/Apple.avif"),
  },
  {
    id: 3,
    name: "IMB",
    logo: require("../../../assets/images/IMB.avif"),
  },
  {
    id: 4,
    name: "Capgemini",
    logo: require("../../../assets/images/Capgemini.avif"),
  },
  {
    id: 5,
    name: "Cognizant",
    logo: require("../../../assets/images/Cognizant.avif"),
  },
  {
    id: 6,
    name: "Bosch",
    logo: require("../../../assets/images/Bosch.avif"),
  },
  {
    id: 7,
    name: "Amazon",
    logo: require("../../../assets/images/Amazon.avif"),
  },
  {
    id: 8,
    name: "GenPack",
    logo: require("../../../assets/images/GenPack.avif"),
  },
  {
    id: 9,
    name: "NetFlix",
    logo: require("../../../assets/images/Netflex.avif"),
  },
];

const YourCareer = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        Fast-track Your Career
      </h1>
      <p className="text-lg text-gray-600 mb-12">
        After completing the course, yslearn learners have made successful
        career transitions, boosted career growth, and got salary hikes.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Learner's Achievements Section */}
        <div className="lg:col-span-1">
          <h2 className="text-xl font-bold text-gray-900 mb-6">
            Learner's Achievements
          </h2>
          <div className="h-[calc(100%-4rem)] flex flex-col justify-between space-y-4">
            {achievementsData?.map((achievement) => (
              <div
                key={achievement.id}
                className="bg-white rounded-lg shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] p-6 border border-[#264b82] border-l-4 flex-1"
              >
                <p className="text-gray-600 mb-2">{achievement.label}</p>
                <p className="text-4xl font-bold text-blue-600">
                  {achievement.value}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Alumni Companies Section */}
        <div className="lg:col-span-3">
          <h2 className="text-xl font-bold text-gray-900 mb-6">
            Our Alumni In Top Companies
          </h2>
          <div className="bg-white rounded-lg shadow-md p-8 border border-grey-400 h-[calc(100%-4rem)]">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8 items-center h-full">
              {companiesData?.map((company) => (
                <div
                  key={company.id}
                  className="flex items-center justify-center"
                >
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="h-12 w-auto object-contain filter grayscale hover:grayscale-0
                                                 transition-all duration-300 opacity-70 hover:opacity-100"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YourCareer;
